import { groq } from 'next-sanity';

import { basicText } from './basicText';
import { gatedContentDownload } from './gatedContentDownload';
import { iframeEmbed } from './iframeEmbed';
import { image } from './image';
import { link } from './link';
import { videoEmbed } from './videoEmbed';
import { videoLoop } from './videoLoop';

export const richText = groq`{
  ...,
  markDefs[] {
    ...(${link}),
    _type == 'anchorId' => {
      _key,
      'id': id.current,
    },
  },
  _type == 'image' => {
    ...${image},
    defined(link) => {
      link[0] ${link},
    },
  },
  _type == 'videoLoop' => ${videoLoop},
  _type == 'quote' => {
    quote[] ${basicText},
    attributionText,
    attributionUrl,
  },
  _type == 'callout' => {
    'icon': select(defined(icon.asset) => icon ${image}, null),
    'libraryIcon': libraryIcon-> {
      _type,
      title,
      svg,
    },
    text,
    link[0] ${link},
    'background': background->color.hex,
  },
  _type == 'iframeEmbed' => ${iframeEmbed},
  _type == 'videoEmbed' => ${videoEmbed},
  _type == 'anchorPoint' => {
    'id': id.current,
  },
  _type == 'legalTable' => {
    title,
    isFirstRowHeader,
    rows[] {
      _key,
      cells[] {
        _key,
        content[] ${basicText}
      }
    }
  },
  _type == 'faqSection' => {
    questions[]-> {
      '_key': _id,
      question,
      answer[] ${basicText},
    },
  },
  _type == 'gatedContentDownload' => ${gatedContentDownload},
}`;
